import qb from "../../assets/images/integration/qb.png";
import xero from "../../assets/images/integration//xero.png";
import freshbooks from "../../assets/images/integration/freshbooks.png";
import google_sheets from "../../assets/images/integration/google_sheets.png";
import mixpanel from "../../assets/images/integration/mixpanel.png";
import clearbit from "../../assets/images/integration/clearbit.png"
import intercom from "../../assets/images/integration/intercom.png"
import oracle from "../../assets/images/integration/oracle.png";
import sap from "../../assets/images/integration/sap.png";
import microsoftDynamic from "../../assets/images/integration/microsoft_dynamic.png";

import yodlee from "../../assets/images/integration/yodlee.png";
import plaid from "../../assets/images/integration/plaid.png";
import trueLayer from "../../assets/images/integration/truelayer.png";
import stripe from "../../assets/images/integration/stripe.png";
import salesforce from "../../assets/images/integration/salesforce.png";
import asana from "../../assets/images/integration/asana.png";
import slack from "../../assets/images/integration/slack.png";
import infor from "../../assets/images/integration/infor.png";
import odoo from "../../assets/images/integration/odoo.png";
import { GoogleSquareFilled } from "@ant-design/icons";

export const accountingSoftware = [
  {
    id: Math.random(),
    title: "Stripe",
    pageUrl: "/home/stripe-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: stripe,
    height: 22,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Salesforce",
    pageUrl: "/home/salesforce-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: salesforce,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Asana",
    pageUrl: "/home/asana-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: asana,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Slack",
    pageUrl: "/home/slack-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: slack,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "QuickBooks",
    pageUrl: "/home/quickbooks-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: qb,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Xero",
    pageUrl: "/home/xero-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: xero,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "FreshBooks",
    pageUrl: "/home/freshbooks-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: freshbooks,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Google Sheets",
    pageUrl: "/home/google-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: google_sheets,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Mixpanel",
    pageUrl: "/home/mixpanel-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: mixpanel,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Clearbit",
    pageUrl: "/home/clearbit-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: clearbit,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Intercom",
    pageUrl: "/home/intercom-dashboard",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    image: intercom,
    height: 30,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "accountingSoftware",
    integratedKeys: null,
  },
];

export const erpSystems = [
  {
    id: Math.random(),
    title: "Oracle NetSuite",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Ipsum generator.",
    image: oracle,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "erpSystems",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "SAP Business One",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Ipsum generator.",
    image: sap,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "erpSystems",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Microsoft Dynamics 365",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Ipsum generator.",
    image: microsoftDynamic,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "erpSystems",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Infor",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Ipsum generator.",
    image: infor,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "erpSystems",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Odoo",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Ipsum generator.",
    image: odoo,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "erpSystems",
    integratedKeys: null,
  }
];

export const bankingAPIs = [
  {
    id: Math.random(),
    title: "Yodlee",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.",
    image: yodlee,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "bankingAPIs",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "Plaid",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.",
    image: plaid,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "bankingAPIs",
    integratedKeys: null,
  },
  {
    id: Math.random(),
    title: "TrueLayer",
    description:
      "Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.",
    image: trueLayer,
    status: "Ready",
    statusColor: "#03A9F4",
    key: "bankingAPIs",
    integratedKeys: null,
  },
];
